import {
  ArrowRight,
  CheckCheck,
  CheckCircle2,
  Clock,
  Users,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Button, Card, CardContent, Chip } from "@mui/material";
import { div, li } from "framer-motion/client";
import { IoCheckmark } from "react-icons/io5";

const courses = [
  {
    id: 4,
    title: "Foundation Course (Class 8)",
    subtitle: "Build Basics. Build Confidence.",
    description:
      "Lay the groundwork with strong fundamentals in Science, Math, English, and Social Science for a lifetime of academic success.",
    points: [
      "✨ Conceptual clarity",
      "🧩 Interactive Learning",
      "🧾 Regular assessments",
      "🌱 Confidence Building:",
      "🧠 Skill Development:",
    ],
    image: "./images/thumbnails/batch thumbnail class 8.png",
    category: "Foundation",
    duration: "Academic Year",
    batchSize: "Small Batch",
    link: "/courses/class-8-foundation",
  },
  {
    id: 5,
    title: "Foundation Course (Class 9)",
    subtitle: "Strengthen Concepts. Boost Confidence.",
    description:
      "Structured preparation for Class 9 students to connect learning with practical application through weekly assessments and tests.",
    points: [
      "📊 Strong Foundation",
      "🧮 Analytical Approach",
      "🧑‍🏫 Personal Mentorship",
      "⏰ Weekly Tests",
      "🚀 Exam Readiness",
    ],
    image: "./images/thumbnails/batch thumbnail class 9.png",

    category: "Foundation",
    duration: "Academic Year",
    batchSize: "Small Batch",
    link: "/courses/class-9-foundation",
  },
  {
    id: 6,
    title: "Board Prep (Class 10)",
    subtitle: "Prepare. Practice. Perform.",
    description:
      "Comprehensive board preparation with chapter-wise tests, full syllabus mocks, and revision cycles for top exam results.",
    points: [
      "🧩 Chapter-Wise Mastery",
      "📚 Full Syllabus Mocks",
      "🧠 Smart Revision Plans",
      "💬 Doubt Clinics",
      "🏆 Performance Analysis",
    ],
    image: "./images/thumbnails/batch thumbnail class 10.png",

    category: "Competitive",
    duration: "3-4 months",
    batchSize: "Small Batch",
    link: "/courses/class-10-board-preparation",
  },
  {
    id: 7,
    title: "Foundation Course (Class 11)",
    subtitle: "The Leap to Higher Learning.",
    description:
      "Focused guidance for transition to senior school with conceptual clarity in Physics, Chemistry, Maths, and Biology.",
    points: [
      "⚛️ Core Subject Focus",
      "🧮 Bridge Learning",
      "📖 Structured Study Plan",
      "🧑‍🏫 Mentor-Led Sessions",
      "🎯 Career Foundation",
    ],
    image: "./images/thumbnails/batch thumbnail class 11.png",

    category: "Competitive",
    duration: "3-4 months",
    batchSize: "Small Batch",
    link: "/courses/class-11-foundation",
  },
  {
    id: 8,
    title: "Board Prep (Class 12)",
    subtitle: "Conquer Boards. Secure Your Future.",
    description:
      "Focused board preparation to master the Class 12 syllabus, maximize scores, and build college-ready confidence.",
    points: [
      "⚛️ Comprehensive Syllabus Coverage",
      "🧮 Advanced Problem Solving",
      "📖 Exam Simulation",
      "✨ Score Enhancement Strategy",
      "🎯 Targeted Doubt Clinics",
    ],
    image: "./images/thumbnails/batch thumbnail class 12.png",

    category: "Competitive",
    duration: "3-4 months",
    batchSize: "Small Batch",
    link: "/courses/class-12-board-preparation",
  },
];

export default function CourseHighlights() {
  const highlightedCourses = courses;

return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {highlightedCourses.map((course) => (
            <Card
                key={course.id}
                className="overflow-hidden border-[#0097b2]/10 hover:shadow-md transition-shadow p-4"
            >
                <div className="relative w-full mb-2">
                    <div className=" overflow-hidden h-[210px] ">
                        <img
                            src={course.image || "/placeholder.svg"}
                            alt={course.title}
                            fill
                            className="object-cover"
                        />
                    </div>
                </div>
                <div>
                    <h1
                        style={{ fontWeight: 600 }}
                        className="text-[#0097b2] text-2xl "
                    >
                        {course.title}
                    </h1>
                    <p>{course.description}</p>
                    <div className="mt-2">
                        <ul>
                            {course.points.map((item, idx) => {
                                return (
                                    <div className="flex items-center">
                                        <IoCheckmark className="mr-1 text-[#e5ad09]" />
                                        <li className=" text-sm text-gray-800" key={idx}>
                                            {item}
                                        </li>
                                    </div>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <CardContent>
                    <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                        <div className="flex items-center">
                            <Clock className="h-4 w-4 mr-1 text-[#0097b2]" />
                            <span>{course.duration}</span>
                        </div>
                        <div className="flex items-center">
                            <Users className="h-4 w-4 mr-1 text-[#0097b2]" />
                            <span>{course.batchSize}</span>
                        </div>
                    </div>
                </CardContent>
                <div>
                    <Link 
                        to={course.link} 
                        className="w-full"
                        onClick={() => window.scrollTo(0, 0)}
                    >
                        <button
                            className="w-full flex   text-white justify-center items-center py-2 bg-[#0097b2] hover:bg-[#007a8f] rounded"
                        >
                            View Details <ArrowRight className="ml-2 h-4 w-4" />
                        </button>
                    </Link>
                </div>
            </Card>
        ))}
    </div>
);
}
